export enum Env {
  dev = 'dev',
  test = 'test',
  prod = 'prod',
}
